import type { InputHTMLAttributes, ReactNode } from 'react'

export function Field({
  label,
  children,
  hint,
}: {
  label: string
  children: ReactNode
  hint?: string
}) {
  return (
    <div className="mb-4">
      <label className="label">{label}</label>
      {children}
      {hint && <p className="mt-1 text-xs text-pfa-slate/70">{hint}</p>}
    </div>
  )
}

export function TextInput(props: InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={`input ${props.className ?? ''}`} />
}

export function Aviso({ children }: { children: ReactNode }) {
  return <div className="aviso">{children}</div>
}

export function ErrorBox({ message }: { message: string | null }) {
  if (!message) return null
  return (
    <div className="rounded-lg border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">{message}</div>
  )
}

export function Money({ value }: { value: number }) {
  return <span className="font-semibold text-pfa-navy">{value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
}
